<template>
  <div>
    <sub-category-button
      v-if="!!subCategories"
      :sub-categories="subCategories"
      @subCategorySelected="filterSubCategory"
    />
    <spotlight-product-list :product-list="productList">
      <template v-slot="slotProps">
        <spotlight-product-card
          :title="getProductContent(slotProps.product).title"
          :text="getProductContent(slotProps.product).text"
          :path="`protection/${slotProps.product.internalName}`"
          @click.native="trackClick($event, `protection.${slotProps.product.internalName}`)"
        >
          <template v-slot:product-logo v-if="isVendor(slotProps.product)">
            <!-- @TODO: Perhaps a better idea to include vendor name to the payload so that multiple products with the same vendor can use the same logo. -->
            <product-logo
              v-if="slotProps.product.internalName.includes('ia_')"
              :name="`ia_dealer_services_${$i18n.locale}`"
              list="productList"
            />
            <product-logo
              v-else-if="slotProps.product.internalName.includes('auto-shield_')"
              :name="`auto-shield_logo`"
              list="productList"
            />
            <product-logo
              v-else-if="slotProps.product.internalName.includes('global-warranty_')"
              :name="`global-warranty_logo`"
              list="productList"
            />
            <product-logo v-else :name="slotProps.product.internalName" list="productList" />
          </template>
        </spotlight-product-card>
      </template>
    </spotlight-product-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import log from '@/services/log';
import { spotlightMixin } from '@/mixins';

const SpotlightProductList = () => import('@/modules/spotlight/components/SpotlightProductList.vue');
const SpotlightProductCard = () => import('@/modules/spotlight/components/SpotlightProductCard.vue');
const SubCategoryButton = () => import('@/modules/spotlight/components/categories/SubCategoryButton.vue');
const ProductLogo = () => import('@/modules/spotlight/containers/ProductLogo.vue');

export default {
  name: 'Protection',
  mixins: [spotlightMixin],
  components: {
    SpotlightProductList,
    SpotlightProductCard,
    SubCategoryButton,
    ProductLogo,
  },
  props: ['subCategories'],
  data() {
    return {
      subCategory: 'all',
    };
  },
  computed: {
    ...mapGetters({
      categories: 'spotlight/getSpotlightCategories',
      vendorList: 'spotlight/getVendorList',
    }),
    productList() {
      const spotlights =
        this.categories.find(payload => payload.category === this.enums.SpotlightConstants.categories.PROTECTION)
          ?.spotlights || [];
      if (this.subCategory !== 'all') {
        return spotlights.filter(spotlight => spotlight.subcategory === this.subCategory);
      }
      return spotlights;
    },
  },
  methods: {
    filterSubCategory(value) {
      this.subCategory = value;
    },
    trackClick(e, spotlight) {
      // Analytics tracking
      const payload = {
        elementInteractedWith: `spotlight.${spotlight}.click`,
      };
      this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
        log('Error in logging interaction', error);
      });
    },
  },
};
</script>

<style scoped></style>
